import React, { MouseEvent } from 'react';
import { useClassName } from '../../utils/useClassName';
import InteractableSurface from '../../Surface/InteractableSurface';
import {
  ContractSuggestionItem,
  ContractSuggestionItemProps
} from '@cube3/cubicle/src/core/molecules/SuggestionItems/ContractSuggestionItem';
import { isMobile } from 'react-device-detect';
import { makeCSS } from '@cube3/cubicle/src/utils/makeCSS';

interface Attachment {
  name: string;
  type: string;
  onClick(ev: MouseEvent): void;
}

interface Props extends ContractSuggestionItemProps {
  selected?: boolean;
  onDoubleClick?(): void;
  onClick?(): void;
  showBorder?: boolean;
}

const useCSS = makeCSS(({ theme }) => {
  return {
    root: {
      marginTop: theme.spacing[2],
      marginBottom: theme.spacing[2],
      maxWidth: 960
    },
    mobileRoot: {
      borderRadius: theme.borderRadius.md,
      border: `1px solid ${theme.color.line['02']}`,
      width: 'calc(100vw - 90px)',
      marginTop: theme.spacing['0.5'],
      marginBottom: theme.spacing['0.5']
    },
    tile: {
      padding: theme.spacing[4]
    },
    selected: {
      background: isMobile ? '' : theme.color.overlay.pressed
    },
    interactive: {
      cursor: 'pointer',
      '&:hover': {
        opacity: 1
      },
      '&:active': {
        background: isMobile ? '' : theme.color.overlay.focused
      }
    }
  };
});

export const ContractTileUI = React.memo<Props>((props) => {
  const {
    item,
    attachments,
    onClick,
    onDoubleClick,
    selected,
    showDate,
    showAttachments,
    showBorder
  } = props;

  const classes = useCSS(props);

  return (
    <div
      className={useClassName(
        isMobile ? classes.mobileRoot : classes.root,
        selected && classes.selected,
        (onClick || onDoubleClick) && classes.interactive
      )}
      onClick={onClick}
      onDoubleClick={onDoubleClick}
    >
      <InteractableSurface
        highlightOnHover={!!(onClick || onDoubleClick)}
        surfaceProps={{
          corners: showBorder ? 'rounded' : undefined,
          cornerRadius: showBorder ? 'mediumEmphasis' : undefined,
          background: 'transparent',
          border: showBorder
        }}
      >
        <div className={classes.tile}>
          <ContractSuggestionItem
            item={item}
            attachments={attachments}
            showAttachments={showAttachments}
            showDate={showDate}
          />
        </div>
      </InteractableSurface>
    </div>
  );
});
